import React, { useEffect, useState } from "react";
import { FooterComponents } from "../FooterComponent";
import SidebarComponent from "../SidbarComponent";
import TopBarComponent from "../TopBarComponent";
import axios from "axios";
import { getDecodedToken, getUserRole, getToken } from '../../utils/auth';
import { GraduationCap, Search, Filter, MapPin, Calendar, UserPlus, X, Loader2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

function ApplicantsList() {
  const [scholarshipData, setScholarshipData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("GOVERNMENT");
  const [assignModal, setAssignModal] = useState({ open: false, scholarship: null });
  const [academicYears, setAcademicYears] = useState([]);
  const [selectedAcademicYear, setSelectedAcademicYear] = useState(
    String(new Date().getFullYear() - 1)
  );
  const navigate = useNavigate();

  const isAdminOrDG = getUserRole() === "Admin" || getUserRole() === "DG";

  const tokenData = getDecodedToken();

  const userPermissionData = sessionStorage.getItem("userPermission");
  const userPermission = (userPermissionData && userPermissionData !== "undefined") ? JSON.parse(userPermissionData) : null;

  


  const fetchScholarshipsByAcademicYear = async (academicYearCode) => {
    setLoading(true);
    try {
      const response = await axios.get(
        process.env.REACT_APP_BASE_URL +
          `hec/abroad/find-scholarships?academicYear=${academicYearCode}`
      );
      setScholarshipData(response.data || []);
    } catch (error) {
      //setError("Failed to fetch scholarships");
      setScholarshipData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchAcademicYears = async () => {
      try {
        const response = await axios.get(
          process.env.REACT_APP_BASE_URL + "hec/academic/getAcademicYears"
        );
        const years = Array.isArray(response.data) ? response.data : [];
        years.sort(
          (a, b) => parseInt(b.academicYearCode) - parseInt(a.academicYearCode)
        );
        setAcademicYears(years);
        // If the default year is not in the list, fall back to the most recent one
        if (years.length > 0) {
          setSelectedAcademicYear((prev) =>
            years.some((y) => String(y.academicYearCode) === prev)
              ? prev
              : String(years[0].academicYearCode)
          );
        }
      } catch (error) {
        setAcademicYears([]);
      }
    };
    fetchAcademicYears();
  }, []);

  useEffect(() => {
    fetchScholarshipsByAcademicYear(selectedAcademicYear);
  }, [selectedAcademicYear]);

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

const filteredScholarships = scholarshipData
    .filter(
        (scholarship) => {
            // First filter by scholarship type
            const typeMatch = scholarship.scholarshipType.toLowerCase().includes(searchTerm?.toLowerCase());
            // If user is SCHOLARSHIP_OWNER, only show the scholarships assigned to them.
            // userPermission is an array of scholarship names; sessions created before
            // the multi-permission change may still hold a single string.
            if (tokenData?.role === "SCHOLARSHIP_OWNER") {
                const permissions = Array.isArray(userPermission)
                    ? userPermission
                    : userPermission
                    ? [userPermission]
                    : [];
                return permissions.some(
                    (permission) =>
                        permission &&
                        scholarship.name.toLowerCase().includes(permission.toLowerCase())
                );
            }
            
            // For other roles, just filter by type
            return typeMatch;
        }
    )
    .sort((a, b) => new Date(b.creationDate) - new Date(a.creationDate));

  const handleScholarshipTypeChange = (type) => {
    if (type === "") {
      setSearchTerm("");
      return;
    }
    setSearchTerm(type);
  };
  const handleAddPrograms = (scholarshipId) => {
    
    navigate(`/educationProgram_scholarship_applicant/${scholarshipId}`);
  };

  return (
    <div className="bg-gray-50">
      <TopBarComponent />
      <aside
        id="logo-sidebar"
        className="app-legacy-aside transition-transform -translate-x-full sm:translate-x-0 bg-white border-r border-gray-200 dark:bg-gray-800 dark:border-gray-700"
        aria-label="Sidebar"
      >
        <SidebarComponent />
      </aside>
      <div className="p-4 sm:ml-64">
        <div className="p-4 border-2 border-white border-b rounded-lg dark:border-gray-700">
          <div className="min-h-screen bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
              <div className="mb-8">
                <h1
                  className="text-3xl font-bold mb-2"
                  style={{ color: "#016b85" }}
                >
                  Abroad Scholarships
                </h1>
                <p style={{ color: "#016b85" }}>
                  Available scholarships for students planning to
                  pursue their studies abroad.
                </p>
              </div>

              {/* Filters */}
              <div
                className="bg-white rounded-lg shadow-sm border p-6 mb-6"
                style={{ borderColor: "#b2dbe3" }}
              >
                <div className="flex flex-col sm:flex-row gap-4">
                  <div className="flex-1">
                    <label htmlFor="academicYear" className="block text-sm font-medium mb-2 text-cyan-800">
                      Academic Year
                    </label>
                    <select
                      id="academicYear"
                      value={selectedAcademicYear}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent"
                      style={{ borderColor: "#b2dbe3" }}
                      onChange={(e) => setSelectedAcademicYear(e.target.value)}
                    >
                      {academicYears.length > 0
                        ? academicYears.map((year) => (
                            <option key={year.id} value={year.academicYearCode}>
                              {year.academicYearName || year.academicYearCode}
                            </option>
                          ))
                        : /* Fallback if the academic years list is unavailable */
                          Array.from({ length: 6 }, (_, i) => {
                            const yearCode = String(new Date().getFullYear() - i);
                            return (
                              <option key={yearCode} value={yearCode}>
                                {yearCode}
                              </option>
                            );
                          })}
                    </select>
                  </div>
                  <div className="flex-1">
                    <label htmlFor="scholarshipType" className="block text-sm font-medium mb-2 text-cyan-800">
                      Scholarship Type
                    </label>
                    <select
                      id="scholarshipType"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent"
                      style={{ borderColor: "#b2dbe3" }}
                      onChange={(e) => {
                        handleScholarshipTypeChange(e.target.value);
                      }}>
                      <option value="">Select Scholarship Type</option>
                      <option value="GOVERNMENT">GOVERNMENT OF RWANDA</option>
                      <option value="COOPERATION">COOPERATION</option>
                    </select>
                  </div>
                </div>
              </div>

              {loading ? (
                <div className="text-center py-12">
                  <div className="w-16 h-16 bg-cyan-100 rounded-full flex items-center justify-center mx-auto mb-4 animate-spin">
                    <GraduationCap className="w-8 h-8 text-cyan-600" />
                  </div>
                  <p className="text-cyan-600">Loading scholarships...</p>
                </div>
              ) : error ? (
                <div className="text-center py-12 bg-red-50 border border-red-200 text-red-700 rounded-lg p-4">
                  <p className="font-medium">We can not find the Scholarships in that academic year {error}</p>
                  <p>Please try again later.</p>
                </div>
              ) : (
                <>
                    <div className="mb-4">
                        <p className="text-sm" style={{ color: "#016b85" }}>
                                      Displaying {filteredScholarships.length} of{" "}
                                      {scholarshipData.length} available scholarships
                        </p>
                    </div>                                            

                                  {/* Table */}
                  <div
                    className="bg-white rounded-lg shadow-sm border overflow-hidden"
                    style={{ borderColor: "#b2dbe3" }}
                  >
                    <div className="overflow-x-auto">
                      <table className="w-full">
                        <thead style={{ background: "#155e75" }}>
                          <tr>
                            <th
                              className="px-6 py-4 text-left text-xs font-medium uppercase tracking-wider"
                              style={{ color: "#ffffff" }}
                            >
                              Scholarship Name
                            </th>
                            <th
                              className="px-6 py-4 text-left text-xs font-medium uppercase tracking-wider"
                              style={{ color: "#ffffff" }}
                            >
                              Country
                            </th>
                            <th
                              className="px-6 py-4 text-left text-xs font-medium uppercase tracking-wider"
                              style={{ color: "#ffffff" }}
                            >
                              Start Date
                            </th>
                            <th
                              className="px-6 py-4 text-left text-xs font-medium uppercase tracking-wider"
                              style={{ color: "#ffffff" }}
                            >
                              End Date
                            </th>
                            <th
                              className="px-6 py-4 text-left text-xs font-medium uppercase tracking-wider"
                              style={{ color: "#ffffff" }}
                            >
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody
                          className="bg-white divide-y"
                          style={{ borderColor: "#e6f3f6" }}
                        >
                          {filteredScholarships.map((scholarship) => (
                            <tr
                              key={scholarship.id}
                              className="hover:bg-[#e6f3f6] transition-colors duration-150"
                            >
                              <td className="px-6 py-4">
                                <div className="flex items-start space-x-3">
                                  <div className="flex-shrink-0">
                                    <div
                                      className="w-10 h-10 rounded-lg flex items-center justify-center"
                                      style={{ background: "#e6f3f6" }}
                                    >
                                      <GraduationCap
                                        className="w-5 h-5"
                                        style={{ color: "#155e75" }}
                                      />
                                    </div>
                                  </div>
                                  <div>
                                    <div
                                      className="text-sm font-medium leading-tight pt-3"
                                      style={{ color: "#155e75" }}
                                    >
                                      {scholarship.name}
                                    </div>
                                    {/* <div
                                      className="text-xs mt-1"
                                      style={{ color: "#7bb8c6" }}
                                    >
                                      ID: {scholarship.id.substring(0, 8)}...
                                    </div> */}
                                  </div>
                                </div>
                              </td>
                              <td className="px-6 py-4">
                                <div className="flex items-center space-x-2">
                                  <MapPin
                                    className="w-4 h-4"
                                    style={{ color: "#7bb8c6" }}
                                  />
                                  <div
                                    className="text-sm"
                                    style={{ color: "#155e75" }}
                                  >
                                    {scholarship.countryName}
                                  </div>
                                </div>
                              </td>
                              <td className="px-6 py-4">
                                <div className="flex items-center space-x-2">
                                  <Calendar
                                    className="w-4 h-4"
                                    style={{ color: "#7bb8c6" }}
                                  />
                                  <div
                                    className="text-sm"
                                    style={{ color: "#155e75" }}
                                  >
                                    {formatDate(scholarship.startDate)}
                                  </div>
                                </div>
                              </td>
                              <td className="px-6 py-4">
                                <div className="flex items-center space-x-2">
                                  <Calendar
                                    className="w-4 h-4"
                                    style={{ color: "#7bb8c6" }}
                                  />
                                  <div
                                    className="text-sm"
                                    style={{ color: "#155e75" }}
                                  >
                                    {formatDate(scholarship.endDate)}
                                  </div>
                                </div>
                              </td>
                              
                              <td className="px-6 py-4">
                                <div className="flex space-x-3">
                                  <button
                                    onClick={() =>
                                      handleAddPrograms(scholarship.id)
                                    }
                                    className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-cyan-600 to-cyan-800 hover:from-cyan-700 hover:to-cyan-900 text-white font-medium rounded-lg shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:ring-offset-2"
                                  >
                                    <GraduationCap className="w-4 h-4 mr-2" />
                                    Programs
                                  </button>
                                  {isAdminOrDG && (
                                  <button
                                    onClick={() =>
                                      setAssignModal({ open: true, scholarship })
                                    }
                                    className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-emerald-600 to-emerald-800 hover:from-emerald-700 hover:to-emerald-900 text-white font-medium rounded-lg shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2">
                                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
                                    </svg>
                                    Assign User
                                  </button>
                                  )}
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {filteredScholarships.length === 0 && (
                      <div className="text-center py-12">
                        <div
                          className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4"
                          style={{ background: "#e6f3f6" }}
                        >
                          <Search
                            className="w-8 h-8"
                            style={{ color: "#7bb8c6" }}
                          />
                        </div>
                        <h3
                          className="text-lg font-medium mb-2"
                          style={{ color: "#016b85" }}
                        >
                          No scholarships found
                        </h3>
                        <p style={{ color: "#7bb8c6" }}>
                          Please refine your search criteria or clear the search
                          to view all available scholarships.
                        </p>
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        <div>
          <FooterComponents />
        </div>
      </div>
      {assignModal.open && assignModal.scholarship && (
        <AssignUserModal
          scholarship={assignModal.scholarship}
          onClose={() => setAssignModal({ open: false, scholarship: null })}
        />
      )}
    </div>
  );
}

// ── Assign User Modal ─────────────────────────────────────────────────────────
// Assigns a user (typically a SCHOLARSHIP_OWNER) to a scholarship by saving the
// scholarship name as the user's permission. At login the permission is stored
// in sessionStorage and used to filter which scholarships the owner can see.
function AssignUserModal({ scholarship, onClose }) {
  const [users, setUsers] = useState([]);
  const [userSearch, setUserSearch] = useState("");
  const [loadingUsers, setLoadingUsers] = useState(true);
  const [selectedUserId, setSelectedUserId] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const timer = setTimeout(async () => {
      setLoadingUsers(true);
      try {
        const params = { page: 0, size: 50 };
        if (userSearch) params.search = userSearch;
        const res = await axios.get(
          process.env.REACT_APP_BASE_URL + "hec/users/admin/all",
          { headers: { Authorization: `Bearer ${getToken()}` }, params }
        );
        setUsers(res.data?.content || []);
      } catch (err) {
        setUsers([]);
        toast.error("Failed to load users. Please try again.", {
          position: "top-center",
          autoClose: 4000,
        });
      } finally {
        setLoadingUsers(false);
      }
    }, 400);
    return () => clearTimeout(timer);
  }, [userSearch]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedUserId) {
      toast.warning("Please select a user.", {
        position: "top-center",
        autoClose: 3000,
      });
      return;
    }
    setIsSubmitting(true);
    try {
      await axios.post(
        process.env.REACT_APP_BASE_URL + "hec/userPermissions/assignPermission",
        null,
        {
          headers: { Authorization: `Bearer ${getToken()}` },
          params: {
            principalId: selectedUserId,
            permissionName: scholarship.name,
          },
        }
      );
      const user = users.find((u) => u.id === selectedUserId);
      toast.success(
        `"${scholarship.name}" assigned to ${user ? `${user.firstName} ${user.lastName}` : "the selected user"}.`,
        { position: "top-center", autoClose: 4000 }
      );
      onClose();
    } catch (err) {
      const msg =
        err.response?.status === 409
          ? "This scholarship is already assigned to that user."
          : err.response?.data?.message ||
            "Failed to assign user. Please try again.";
      toast.error(msg, { position: "top-center", autoClose: 4000 });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 bg-gradient-to-r from-emerald-50 to-white">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-full bg-emerald-100 flex items-center justify-center">
              <UserPlus className="w-4 h-4 text-emerald-600" />
            </div>
            <div>
              <h2 className="text-lg font-bold text-gray-900">Assign User</h2>
              <p className="text-xs text-gray-500 mt-0.5 max-w-[260px] truncate">
                {scholarship.name}
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="px-6 pt-5 pb-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1.5">
              Search User
            </label>
            <div className="relative">
              <Search className="w-4 h-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" />
              <input
                type="text"
                value={userSearch}
                onChange={(e) => setUserSearch(e.target.value)}
                placeholder="Search by name or email..."
                className="w-full pl-9 pr-3 py-2.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1.5">
              Select User
            </label>
            {loadingUsers ? (
              <div className="flex items-center gap-2 text-sm text-gray-400 py-2">
                <Loader2 className="w-4 h-4 animate-spin" />
                Loading users...
              </div>
            ) : (
              <select
                value={selectedUserId}
                onChange={(e) => setSelectedUserId(e.target.value)}
                required
                className="w-full px-3 py-2.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none bg-white"
              >
                <option value="">-- Select a user --</option>
                {users.map((user) => (
                  <option key={user.id} value={user.id}>
                    {user.firstName} {user.lastName} — {user.roleName}
                    {user.email ? ` (${user.email})` : ""}
                  </option>
                ))}
              </select>
            )}
            {!loadingUsers && users.length === 0 && (
              <p className="text-xs text-gray-400 mt-1.5">
                No users found. Try a different search.
              </p>
            )}
          </div>

          <div className="flex gap-3 pt-2">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-4 py-2.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isSubmitting || loadingUsers}
              className="flex-1 flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-medium text-white bg-emerald-600 rounded-lg hover:bg-emerald-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            >
              {isSubmitting ? (
                <Loader2 className="w-4 h-4 animate-spin" />
              ) : (
                <UserPlus className="w-4 h-4" />
              )}
              {isSubmitting ? "Assigning..." : "Assign User"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ApplicantsList;
